import { useEffect, useRef, useState } from "react";
import "./AcceptPolicies.css"
import { botLogo, checkedButton } from "../../../../utils";
import { createAxiosInstance } from "../../../../services/authService";
import { Checkbox } from "../../../generalComponents/Checkbox/Checkbox";
import {logDebug, logTrace,logError} from "../../../../utils/logger";
import React from "react";
import {useAppContext} from "../../../../AppDataContext";

const updateLegal = async (data: { client_name: string, user_id: string, client_token: string, proxy: string|undefined }) => {
    try {
        // logDebug('data.proxy_______:', data.proxy);
        const response = await createAxiosInstance(data.proxy).post('/update_legal', data, {
            headers: {
                Authorization: "Bearer " + data.client_token
            }
        });
        logDebug('Response:', response.data);
    } catch (error) {
        logError('Error: ', error);
    }
};

function getKeyByValue(obj:any, value:any) {
  return Object.keys(obj).find(key => obj[key].trim() === value.trim()) || value.trim();
}

const renderTextWithElements = (text: string, links: Record<string, string>,text_to_params:Record<string,string>) => {
    let content = text;
    Object.keys(text_to_params).forEach((key) => {
         content = content.replace(key,text_to_params[key]);
      logTrace(text_to_params[key]); // This will log the value associated with the key
});
    logDebug(content)
  const words = content.split(" ");
  return words.map((word, index) => {
    const cleanWord = word.replace(/[,\.]/g, ""); // Remove punctuation for matching
    if (links[cleanWord]) {

      return (
        <React.Fragment key={index}>
          <a href={links[cleanWord]} target="_blank">
            {getKeyByValue(text_to_params,cleanWord)}
          </a>
           {word.endsWith(",") || word.endsWith(".") ?  word.slice(-1)  : " "}
        </React.Fragment>
      );
    }
    return word + " ";
  });
};

export const AcceptPolicies = ({ setVersions, getMyHeight, userId, client_id, client_token, proxy , onAccept}:
                                   { userId: string, client_id: string, setVersions: React.Dispatch<React.SetStateAction<boolean>>,
                                       getMyHeight: React.Dispatch<React.SetStateAction<number>>, client_token: string, proxy: string|undefined, onAccept: () => void  }) => {

    // logDebug('proxy_______:', proxy);
    const appDataContent = useAppContext()
    const [checked, setChecked] = useState(false);
    const handleChecked = () => {
        setChecked(!checked);
    };
    const locale_messages = new Map<string, any>(Object.entries(require('../../../../ds/locale.json')));
    const languageKey = appDataContent.language_for_chat || "EN";
    const accept_policies =  Object.assign({}, ...(locale_messages.get(languageKey)?.accept_policies));
    const content_header = accept_policies.content_header || "AI Driven Portfolio Assistant Powered by WNSTN";
    const content_title = accept_policies.content_title || "Activate your assistant";
    const text = accept_policies.content || "I have read and agree to WNSTN Terms of Service, Privacy Policy, and Disclaimer";
   const submit = accept_policies.submit || "Submit";
    const terms = accept_policies.terms_of_service || "Terms of Service";
    const privacy = accept_policies.privacy_policy || "Privacy Policy";
    const disclaimer = accept_policies.disclaimer || "Disclaimer";
    const arr = [terms, privacy, disclaimer];
        const text_to_params = {
          [arr[0]]: " {terms_of_service} ",
          [arr[1]]: " {privacy_policy} ",
          [arr[2]]: " {disclaimer} "
        };

        const links = {
          "{terms_of_service}": "http://wnstn.ai/terms-of-service",
          "{privacy_policy}": "http://wnstn.ai/privacy-policy",
          "{disclaimer}": "http://wnstn.ai/disclaimer"
        };
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (sectionRef.current && sectionRef.current.offsetHeight)
            getMyHeight(sectionRef.current.offsetHeight);
    }, [])


    return <section className="acceptAllPolicies" ref={sectionRef}>
        <div className="policies__title">
            <div className="ptitle__logo">
                <img src={botLogo} alt="titleLogo" />
            </div>
            <p className="ptitle__name">
                {content_header}
            </p>
            <p className="ptitle__suggestion">
                {content_title}
            </p>
        </div>
        <div className="policies__accepting">
            <label> 
                <Checkbox checked={checked} handleChecked={handleChecked} checkedButtonImg={checkedButton}/>
                {/*<span>I have read and agree to WNSTN*/}
                {/*    <a href="http://wnstn.ai/terms-of-service" target="_blank">Terms of Service,</a>*/}
                {/*    <a href="http://wnstn.ai/privacy-policy" target="_blank">Privacy Policy,</a> and*/}
                {/*    <a href="http://wnstn.ai/disclaimer" target="_blank">Disclaimer</a></span>*/}
                 <span>{renderTextWithElements(text, links,text_to_params)}</span>
            </label>
        </div>
        <button className={`policies__acceptButton ${checked ? 'policies__acceptButton__checked' : ''}`} disabled={!checked} onClick={() => {

            const updatedLegal =  updateLegal({client_name: client_id, user_id: userId, client_token, proxy});
            // logDebug(updatedLegal, " - updatedLegal");
            setVersions(false);
            onAccept();
        }}>
            <img src={checkedButton} alt="checked" />
            <span>{submit}</span>
        </button>
    </section>
}

